import BARBA_EXT_1 from "./BARBA_EXT_1";
export default {
  BARBA_EXT_1,
};
